import React from 'react';
import PropTypes from 'prop-types';
import { Sources } from '@medflex/shared-types';
import {
  ChatBubbleLeftRightIcon,
  IdentificationIcon,
  PhoneIcon,
  DocumentIcon,
  HomeModernIcon,
} from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import Badge, { KINDS } from '../Badge';
import Tooltip from '../Tooltip';

const SOURCES_TO_ICON = {
  [Sources.PHONE]: <PhoneIcon className="-ml-1 w-5 h-5" />,
  [Sources.CONTACT_PAGE]: <IdentificationIcon className="-ml-1 w-5 h-5" />,
  [Sources.MESSENGER]: <ChatBubbleLeftRightIcon className="-ml-1 w-5 h-5" />,
  [Sources.QUESTIONNAIRE]: <DocumentIcon className="-ml-1 w-5 h-5" />,
  [Sources.PRACTICE]: <HomeModernIcon className="-ml-1 w-5 h-5" />,
};

const InquirySourceBadge = ({ requestSource }) => {
  const { t } = useTranslation('components', { keyPrefix: 'PamInquiry' });

  return (
    <Badge kind={KINDS.SECONDARY} className="space-x-1">
      <Tooltip title={t('sources_tooltip')} preventOverflow>
        <div className="flex flex-row items-center space-x-1">
          {SOURCES_TO_ICON[requestSource]}
          <span>{t(`sources.${requestSource}`)}</span>
        </div>
      </Tooltip>
    </Badge>
  );
};

InquirySourceBadge.propTypes = {
  requestSource: PropTypes.oneOf(Object.values(Sources)).isRequired,
};

export default InquirySourceBadge;
